import React from "react";
import DesafiosTabs from "../../components/DesafiosTabs";

import imgEscudo from "../../assets/img_escudo.svg";

import "./styles.css";

const Render = (props, context) => {
  return (
    <section className="dataEntry int pbxl">
        <div className="container">    
            <h1 className="avenirBK violet">Desafíos</h1>
            <DesafiosTabs />
            <div className="dataEntryPanel clearfix">
                <div className="user borderBox floatLeft">
                    <img src={imgEscudo} className="displayBlock mha mbm" alt="" />
                    <h2 className="avenirBK violet alignCenter">Data Entry</h2>
                    <p className="alignCenter">Lorem ipsum</p>
                </div>
                <div className="txt floatLeft">
                    <p>Para designar la lengua común de España y de muchas naciones de América, y que también se habla como propia en otras partes del mundo, son válidos los términos castellano y español. La polémica sobre cuál de estas denominaciones resulta más apropiada está hoy superada.</p>
                    <p>El término español resulta más recomendable por carecer de ambigüedad, ya que se refiere de modo unívoco a la lengua que hablan hoy más de cuatrocientos millones de personas. Asimismo, es la denominación que se utiliza internacionalmente (Spanish, espagnol, Spanisch, spagnolo, etc.). Aun siendo también sinónimo de español, resulta preferible reservar el término castellano para referirse al dialecto románico nacido en el Reino de Castilla durante la Edad Media, o al dialecto del español que se habla actualmente en esta región. En España, se usa asimismo el nombre castellano cuando se alude a la lengua común del Estado en relación con las otras lenguas cooficiales en sus respectivos territorios autónomos, como el catalán, el gallego o el vasco.</p>
                </div>
            </div>
        </div>
    </section>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/DataEntry/Render.js